// import React from "react";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = !!localStorage.getItem("phoneNumber"); // Check if phoneNumber exists
//   return isAuthenticated ? children : <Navigate to="/" />;
// };

// export default ProtectedRoute;



import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { restoreSession } from "../actions/authActions";
import { useEffect, useState } from "react";
const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(state => state.auth);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // If not authenticated in Redux, try to restore from localStorage
    if (!isAuthenticated) {
      const sessionRestored = dispatch(restoreSession());
      if (!sessionRestored) {
        // No session in localStorage either
        setIsLoading(false);
        return;
      }
    }
    setIsLoading(false);
  }, [dispatch, isAuthenticated]);
  // Show loading while checking authentication
  if (isLoading) {
    return <div>Loading...</div>;  
  }
  // Check both Redux state and localStorage
  const localStorageAuth = !!localStorage.getItem("phoneNumber");
  const isAuthenticatedFinal = isAuthenticated || localStorageAuth;
  
  return isAuthenticatedFinal ? children : <Navigate to="/" />;
};
export default ProtectedRoute;